(ns dre.pages.my-searches.search-history.events
  (:require
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [dre.components.pill :as pill]
   [dre.components.flash.events :as-alias flash]
   [dre.network :as-alias network]
   [dre.utils :refer [aborted-request?]]
   [dre.utils.query :as q]
   [dre.shared.interface.search.util :refer [normalized-blunt]]
   [re-frame.core :as rf]
   [superstructor.re-frame.fetch-fx :as-alias fetch-fx]))

(def db-path :search-history)

(defn render-event
  [payload]
  [pill/readonly-pills (:query/pills (q/coerce {:query/pills payload})) nil nil nil {}])

;; -- Events

(rf/reg-event-fx
 ::fetch
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [_ [_]]
  {:db {:state :loading}
   ::network/request [{:endpoint :saved/search-history}
                      {:params {:limit 10}
                       :on-success [::success-fetch]
                       :on-failure [::failure-fetch]}]}))

(rf/reg-event-fx
 ::success-fetch
 [rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [::fetch-fx/response]}]]
  (let [signals-map (into (sorted-map) (map (fn [e] 
                                              [(normalized-blunt (get-in e [:query/search-query])) e]) 
                                  (get-in db [:signals :data :signals])))
        events (map (fn [e]
                      (if-let [signal (get signals-map (normalized-blunt {:query/pills (:payload e)}) nil)]
                        (assoc e :title (:signal/title signal) :signal signal)
                        (assoc e :title "Untitled" :signal nil))) 
                    (:events (:body response)))]
    {:db (-> db
             (assoc-in [db-path :state] :success)
             (assoc-in [db-path :data] events))})))

(rf/reg-event-fx
 ::failure-fetch
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [::fetch-fx/response] :as opts}]]
  (if (aborted-request? response)
    {}
    {:db (-> db
             (assoc :state :failure)
             (assoc :data nil))
     :dispatch-n [[:dre.network/default-failure opts]]})))

;; -- Subscriptions

(rf/reg-sub
 ::state
 (fn [db _]
   (db-path db)))

(rf/reg-sub
 ::data
 :<- [::state]
 (fn [state _]
   (get-in state [:data] nil)))

(rf/reg-sub
 ::loading?
 :<- [::state]
 (fn [state _]
   (let [data (get-in state [:state] nil)]
     (= :loading data))))